import { render, staticRenderFns } from "./AppConfigMain.vue?vue&type=template&id=37223a33&scoped=true&lang=pug"
import script from "./appConfig.js?vue&type=script&lang=js&external"
export * from "./appConfig.js?vue&type=script&lang=js&external"
import style0 from "./AppConfigMain.vue?vue&type=style&index=0&id=37223a33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37223a33",
  null
  
)

export default component.exports